import { Item } from '../item'

export default class OrderMenuCategory {
  name = ''
  categoryId = ''
  items: Item[] = []
  translations: { [locale: string]: string } = {}
}
